import Slider from "/Assets/libs/slider.js";
import { onReady } from "/Assets/js/utilities.js";

export default class HeroShotSlider {
    init() {
        onReady(() => {
            var selector = ".hero-shot-slider";
            var initializeSlider = document.querySelector(selector);
            if (!initializeSlider)
                return;

            var clsPrefix = "slider";
            var duration = 500;
            var autoSlider = initializeSlider.dataset.auto;
            var autoBool = (autoSlider === "true");
            var slideInterval = initializeSlider.dataset.slideInterval == 0 ? 10000 : initializeSlider.dataset.slideInterval;

            const slider = new Slider({
                selector: selector,
                clsPrefix: clsPrefix,
                duration: duration,
                loop: true,
                onChange: () => {
                    slider.updatePagination(clsPrefix + "__pagination-btn", clsPrefix + "__item");
                    slider.setAutoHeight();
                }
            });

            slider.setAutoHeight();

            if (autoBool) {
                slider.setHoverPause(slideInterval);
            }

            slider.setPagination(clsPrefix + "__pagination", clsPrefix + "__pagination-btn", clsPrefix + "__item");

            const prev = document.querySelector(".hero-shot-slider-wrap .hero-shot-slider-prev");
            const next = document.querySelector(".hero-shot-slider-wrap .hero-shot-slider-next");
            if (prev) {
                prev.addEventListener("click", () => slider.prev());
            }
            if (next) {
                next.addEventListener("click", () => slider.next());
            }

            //unhide image overlays. hidden to reduce visual flash until slider is ready
            setTimeout(function () {
                let overlays = document.querySelectorAll(".hero-shot-overlay");
                [].forEach.call(overlays, function (overlay) {
                    overlay.classList.remove("loading");
                });
            }, 300);
        });
    }
}
